import React from 'react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-blue-600 text-white">
        <div className="max-w-4xl mx-auto px-6 py-16 text-center">
          <h1 className="text-5xl font-bold mb-4">Terms of Service</h1>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="prose prose-lg max-w-none">
          {/* 1. Acceptance of Terms */}
          <section className="mb-12">
            <div className="bg-gray-50 p-8 rounded-lg border">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 pb-4 border-b-2 border-blue-600">
                1. Acceptance of Terms
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                By accessing or using MARS's services, you agree to be bound by these Terms. If you do not agree, do not use our services.
              </p>
            </div>
          </section>

          {/* 2. Eligibility */}
          <section className="mb-12">
            <div className="bg-gray-50 p-8 rounded-lg border">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 pb-4 border-b-2 border-blue-600">
                2. Eligibility
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                You must be at least 18 years old to use our services.
              </p>
            </div>
          </section>

          {/* 3. Account Registration */}
          <section className="mb-12">
            <div className="bg-gray-50 p-8 rounded-lg border">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 pb-4 border-b-2 border-blue-600">
                3. Account Registration
              </h2>
              <div className="grid gap-4">
                <div className="flex items-start p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
                  <div className="w-4 h-4 bg-blue-600 rounded-full mt-2 mr-6 flex-shrink-0"></div>
                  <p className="text-lg text-gray-700">You may need to create an account for certain features</p>
                </div>
                <div className="flex items-start p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
                  <div className="w-4 h-4 bg-blue-600 rounded-full mt-2 mr-6 flex-shrink-0"></div>
                  <p className="text-lg text-gray-700">Keep your credentials confidential</p>
                </div>
                <div className="flex items-start p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
                  <div className="w-4 h-4 bg-blue-600 rounded-full mt-2 mr-6 flex-shrink-0"></div>
                  <p className="text-lg text-gray-700">Provide accurate information</p>
                </div>
                <div className="flex items-start p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
                  <div className="w-4 h-4 bg-blue-600 rounded-full mt-2 mr-6 flex-shrink-0"></div>
                  <p className="text-lg text-gray-700">You're responsible for all account activities</p>
                </div>
              </div>
            </div>
          </section>

          {/* 4. Use of Services */}
          <section className="mb-12">
            <div className="bg-gray-50 p-8 rounded-lg border">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 pb-4 border-b-2 border-blue-600">
                4. Use of Services
              </h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Use our services lawfully. You shall not:
              </p>
              <div className="grid gap-4">
                <div className="flex items-start p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
                  <div className="w-4 h-4 bg-blue-600 rounded-full mt-2 mr-6 flex-shrink-0"></div>
                  <p className="text-lg text-gray-700">Use MARS for illegal or unauthorized purposes</p>
                </div>
                <div className="flex items-start p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
                  <div className="w-4 h-4 bg-blue-600 rounded-full mt-2 mr-6 flex-shrink-0"></div>
                  <p className="text-lg text-gray-700">Interfere with platform security or functionality</p>
                </div>
                <div className="flex items-start p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
                  <div className="w-4 h-4 bg-blue-600 rounded-full mt-2 mr-6 flex-shrink-0"></div>
                  <p className="text-lg text-gray-700">Copy or exploit our services without permission</p>
                </div>
              </div>
            </div>
          </section>

          {/* 5. Payments and Subscriptions */}
          <section className="mb-12">
            <div className="bg-gray-50 p-8 rounded-lg border">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 pb-4 border-b-2 border-blue-600">
                5. Payments and Subscriptions
              </h2>
              <div className="grid gap-4">
                <div className="flex items-start p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
                  <div className="w-4 h-4 bg-blue-600 rounded-full mt-2 mr-6 flex-shrink-0"></div>
                  <p className="text-lg text-gray-700">Some features may require payment</p>
                </div>
                <div className="flex items-start p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
                  <div className="w-4 h-4 bg-blue-600 rounded-full mt-2 mr-6 flex-shrink-0"></div>
                  <p className="text-lg text-gray-700">Payment information must be accurate</p>
                </div>
                <div className="flex items-start p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
                  <div className="w-4 h-4 bg-blue-600 rounded-full mt-2 mr-6 flex-shrink-0"></div>
                  <p className="text-lg text-gray-700">Fees are generally non-refundable</p>
                </div>
                <div className="flex items-start p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
                  <div className="w-4 h-4 bg-blue-600 rounded-full mt-2 mr-6 flex-shrink-0"></div>
                  <p className="text-lg text-gray-700">We may change pricing with notice</p>
                </div>
              </div>
            </div>
          </section>

          {/* 6. Intellectual Property */}
          <section className="mb-12">
            <div className="bg-gray-50 p-8 rounded-lg border">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 pb-4 border-b-2 border-blue-600">
                6. Intellectual Property
              </h2>
              <div className="grid gap-4">
                <div className="flex items-start p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
                  <div className="w-4 h-4 bg-blue-600 rounded-full mt-2 mr-6 flex-shrink-0"></div>
                  <p className="text-lg text-gray-700">All content is owned by MARS or licensors</p>
                </div>
                <div className="flex items-start p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
                  <div className="w-4 h-4 bg-blue-600 rounded-full mt-2 mr-6 flex-shrink-0"></div>
                  <p className="text-lg text-gray-700">Written permission required for use</p>
                </div>
              </div>
            </div>
          </section>

          {/* 7. User Content */}
          <section className="mb-12">
            <div className="bg-gray-50 p-8 rounded-lg border">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 pb-4 border-b-2 border-blue-600">
                7. User Content
              </h2>
              <div className="grid gap-4">
                <div className="flex items-start p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
                  <div className="w-4 h-4 bg-blue-600 rounded-full mt-2 mr-6 flex-shrink-0"></div>
                  <p className="text-lg text-gray-700">You grant us license to use submitted content</p>
                </div>
                <div className="flex items-start p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
                  <div className="w-4 h-4 bg-blue-600 rounded-full mt-2 mr-6 flex-shrink-0"></div>
                  <p className="text-lg text-gray-700">You're responsible for your content's legality</p>
                </div>
              </div>
            </div>
          </section>

          {/* 8. Termination */}
          <section className="mb-12">
            <div className="bg-gray-50 p-8 rounded-lg border">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 pb-4 border-b-2 border-blue-600">
                8. Termination
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                We may suspend or terminate accounts for Terms violations.
              </p>
            </div>
          </section>

          {/* 9. Disclaimers */}
          <section className="mb-12">
            <div className="bg-gray-50 p-8 rounded-lg border">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 pb-4 border-b-2 border-blue-600">
                9. Disclaimers
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                Services provided "as is" without warranties. No guarantee of uninterrupted or error-free service.
              </p>
            </div>
          </section>

          {/* 10. Limitation of Liability */}
          <section className="mb-12">
            <div className="bg-gray-50 p-8 rounded-lg border">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 pb-4 border-b-2 border-blue-600">
                10. Limitation of Liability
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                MARS won't be liable for indirect, incidental, or consequential damages.
              </p>
            </div>
          </section>

          {/* 11. Contact */}
          <section className="mb-12">
            <div className="bg-blue-50 border border-blue-200 p-8 rounded-lg">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 pb-4 border-b-2 border-blue-600">
                11. Contact
              </h2>
              <div className="flex items-center">
                <svg className="w-6 h-6 text-blue-600 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <h4 className="text-xl font-semibold text-gray-900 mr-2">Email:</h4>
                <a href="mailto:mars@mediacle.com" className="text-xl text-blue-700 hover:text-blue-900 font-medium hover:underline">
                  mars@mediacle.com
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-gray-900 text-white py-8">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="text-gray-300">© 2026 MARS. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;